<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraph1">
<p class="noindent">“A shaman? A shaman is the knower of the path, the seer of truth, the wanderer of the hidden ways. The dude who is in the know, the one who sees what the kids are too dumb to look at. To put it in little words so as you’ll understand—your half-decent shaman always knows where the nearest public bog is, and if it’s worth legging it for the bus.”</p>
<p class="attribution"><a id="page-v"></a>Samuel the Elbow, <em>How to Be a Shaman—a Beginner’s Guide</em></p>
</div>
<div class="epigraph">
<p class="noindent">“They say that the soul of the city is being ripped apart.</p>
<p>I’ve never had much time for ‘them’ and the things ‘they’ say but, for once, I find myself forced to agree. It begins with a rusting, a place where new foundations were laid and which are now turned to orange-brown. Then a cracking, the road beneath your feet splitting though the tarmac is fresh. Then a dripping, the water coming through from the pipes overhead, then a creaking; wood splinters against wood, glass breaks and someone may leave a bin bag behind the pane to keep out the draught but that is all, and it is forgotten, and it withers, and it dies. People don’t understand how a city dwindles like a living thing, but that is what it is and, like all things that live, it too can die.</p>
<p>And this shaking, this crumbling, this death by little silences falling in busy streets, this hollowness of all things—I am powerless to prevent.”</p>
<p class="attribution">M. Swift, 127th Midnight Mayor of London</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4ccf2bd5